import B2ChatClient from '@client-sdk';
import { updateBotTrayConfigSuccess } from '@src/actions/common';
import {
  updateBotTrayConfig,
  updateBotTrayConfigFailure,
} from '@src/reducers/consoleGeneralSettings';
import { getMerchantId } from '@src/selectors/user';
import { ErrorData } from '@types';
import { B2ChatAPI } from '@types-api';
import { call, put, select, takeLatest } from 'redux-saga/effects';

function* updateBotTrayConfigSaga(
  action: ReturnType<typeof updateBotTrayConfig>
) {
  const merchantId: string = yield select(getMerchantId);
  try {
    const { error }: B2ChatAPI.Response<unknown> = yield call(
      B2ChatClient.resources.merchant.actions.updateMerchantPreferences,
      {
        params: { merchantId },
        data: {
          agentConsoleConfig: action.payload,
        },
      }
    );

    if (!error) {
      yield put(updateBotTrayConfigSuccess(action.payload));
    } else {
      yield put(updateBotTrayConfigFailure(error as ErrorData));
    }
  } catch (error) {
    yield put(updateBotTrayConfigFailure(error as ErrorData));
  }
}

export default function* consoleGeneralSettingsSaga() {
  yield takeLatest(updateBotTrayConfig, updateBotTrayConfigSaga);
}
